<template>
<div class="chapter">
<div class="inner_page">
<div id="eBook4242-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="Title para-style-override-2" id="toc_marker-4"><span class="char-style-override-6">S</span><span class="char-style-override-7">INGING</span><span class="char-style-override-6"><br/></span><span class="char-style-override-7">AT THE</span><span class="char-style-override-6"> G</span><span class="char-style-override-7">ATES</span></p>
<p class="poems para-style-override-3"><span class="char-style-override-8">Selected Poems</span></p>
<p class="poems para-style-override-4"><span class="char-style-override-6">J</span><span class="char-style-override-9">IMMY</span><span class="char-style-override-6"> S</span><span class="char-style-override-9">ANTIAGO</span><span class="char-style-override-6"> B</span><span class="char-style-override-9">ACA</span></p>
<p class="poems para-style-override-5"><img alt="V-1.tif" class="image" src="images/V-1_fmt.png" width="11%"/></p>
<p class="poems para-style-override-6">Grove Press</p>
<p class="poems para-style-override-6"><span class="char-style-override-5">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42423.vue?f3a46f18